<div class="optout-page d-flex flex-column min-vh-100">
  <app-header></app-header>

  <main class="main-content flex-fill">
    <div class="content-container container">
      @if (tokenError()) {
        <div class="content-container container my-5">
          <crnt-callout variant="cautionary">
            {{ tokenErrorMessage() }}
            <a [href]="translationService.t().emailPreferencesUrl">{{
              translationService.t().mijnDomain
            }}</a>
          </crnt-callout>
        </div>
      }

      @if (!tokenError() && !saveSuccess() && hasOptionalConsents()) {
        <h1 class="crnt-typography-display text-center my-5">
          {{ translationService.t().mainHeading }}
        </h1>

        <div class="preferences-section mb-5">
          <div class="preference-cards d-flex flex-column gap-4">
            @for (card of optionalEmailPreferenceCards(); track card.controlName) {
              <app-email-preference-card
                class="mb-0"
                [title]="card.title"
                [description]="card.description"
                [controlName]="card.controlName"
                [checked]="preferenceForm().get(card.controlName)?.value || false"
                (checkedChange)="onCheckboxChange(card.controlName, $event)"
              ></app-email-preference-card>
            }
          </div>
        </div>
      }
    </div>

    <div class="content-container container">
      <div class="save-section d-flex flex-column gap-4">
        @if (saveSuccess()) {
          <div class="success-message my-5">
            <h2 class="success-title crnt-typography-display mb-4">
              {{ translationService.t().successTitle }}
            </h2>
            @if (savedOptedInConsents().length > 0) {
              <p class="crnt-typography-body-functional mb-2">
                {{ translationService.t().successStillReceiving }}
              </p>
              <ul class="crnt-typography-body-functional mb-3">
                @for (title of savedOptedInConsents(); track title) {
                  <li>{{ title }}</li>
                }
              </ul>
            }
            @if (savedOptedOutConsents().length > 0) {
              <p class="crnt-typography-body-functional mb-2">
                {{ translationService.t().successOptedOut }}
              </p>
              <ul class="crnt-typography-body-functional mb-3">
                @for (title of savedOptedOutConsents(); track title) {
                  <li>{{ title }}</li>
                }
              </ul>
            }
            <p class="crnt-typography-body-functional mb-4">
              {{ translationService.t().successFooter }}
            </p>
            <crnt-button
              [state]="'enabled'"
              (click)="navigateToPreferences()"
              (keydown.enter)="navigateToPreferences()"
              variant="secondary"
            >
              {{ translationService.t().successButton }}
            </crnt-button>
          </div>
        }
        @if (saveError()) {
          <div class="error-message crnt-typography-body-functional px-3 py-3 rounded my-5">
            {{ translationService.t().errorMessage }}
          </div>
        }
        @if (!saveSuccess() && hasOptionalConsents()) {
          <div class="d-flex justify-content-center my-5">
            <crnt-button
              [state]="isSaving() || !preferenceForm().valid ? 'disabled' : 'enabled'"
              (click)="savePreferences()"
              (keydown.enter)="savePreferences()"
            >
              {{
                isSaving() ? translationService.t().savingButton : translationService.t().saveButton
              }}
            </crnt-button>
          </div>
        }
      </div>
    </div>

    <div class="mandatory-section-wrapper my-6">
      <div class="mandatory-section">
        <div class="content-container container py-6">
          <h2 class="crnt-typography-heading-2 mb-5 fw-bold">Deze emails sturen we altijd.</h2>
          <div class="mandatory-cards d-flex flex-column gap-4">
            @for (card of mandatoryEmailInfoCards(); track card.title) {
              <app-mandatory-email-info-card
                class="mb-0"
                [title]="card.title"
                [description]="card.description"
                [buttonText]="card.buttonText"
                [buttonLink]="card.buttonLink"
              ></app-mandatory-email-info-card>
            }
          </div>
        </div>
      </div>
    </div>
  </main>

  <app-footer></app-footer>
</div>
